module.exports = __webpack_public_path__ + "static/media/mineracao.733bd6c3.jpg";